module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8011.090898df.png";